/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Carriers API
 * Carrier-facing API for the carrier portal (carriers.freightsimple.com).  Authentication: a carrier opens a permanent signed login link, exchanges it for a session token, and presents that token as a bearer on every other call. `CarrierPortalAuthenticationFilter` validates the session and scopes each request to one carrier. Operations use `security: []` (no Micronaut JWT) — the filter is the authenticator, the same model the agents API uses.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { PerformanceVolumeMonthRow } from "./PerformanceVolumeMonthRow";
import {
  PerformanceVolumeMonthRowFromJSON,
  PerformanceVolumeMonthRowFromJSONTyped,
  PerformanceVolumeMonthRowToJSON,
  PerformanceVolumeMonthRowToJSONTyped,
} from "./PerformanceVolumeMonthRow";
import type { PerformanceOnTimeMonthRow } from "./PerformanceOnTimeMonthRow";
import {
  PerformanceOnTimeMonthRowFromJSON,
  PerformanceOnTimeMonthRowFromJSONTyped,
  PerformanceOnTimeMonthRowToJSON,
  PerformanceOnTimeMonthRowToJSONTyped,
} from "./PerformanceOnTimeMonthRow";
import type { PerformanceCspUtilisation } from "./PerformanceCspUtilisation";
import {
  PerformanceCspUtilisationFromJSON,
  PerformanceCspUtilisationFromJSONTyped,
  PerformanceCspUtilisationToJSON,
  PerformanceCspUtilisationToJSONTyped,
} from "./PerformanceCspUtilisation";
import type { PortalCurrency } from "./PortalCurrency";
import {
  PortalCurrencyFromJSON,
  PortalCurrencyFromJSONTyped,
  PortalCurrencyToJSON,
  PortalCurrencyToJSONTyped,
} from "./PortalCurrency";
import type { PerformanceCompetitiveness } from "./PerformanceCompetitiveness";
import {
  PerformanceCompetitivenessFromJSON,
  PerformanceCompetitivenessFromJSONTyped,
  PerformanceCompetitivenessToJSON,
  PerformanceCompetitivenessToJSONTyped,
} from "./PerformanceCompetitiveness";
import type { PerformanceFreightProfile } from "./PerformanceFreightProfile";
import {
  PerformanceFreightProfileFromJSON,
  PerformanceFreightProfileFromJSONTyped,
  PerformanceFreightProfileToJSON,
  PerformanceFreightProfileToJSONTyped,
} from "./PerformanceFreightProfile";
import type { PerformanceKpis } from "./PerformanceKpis";
import {
  PerformanceKpisFromJSON,
  PerformanceKpisFromJSONTyped,
  PerformanceKpisToJSON,
  PerformanceKpisToJSONTyped,
} from "./PerformanceKpis";
import type { PerformanceLaneRow } from "./PerformanceLaneRow";
import {
  PerformanceLaneRowFromJSON,
  PerformanceLaneRowFromJSONTyped,
  PerformanceLaneRowToJSON,
  PerformanceLaneRowToJSONTyped,
} from "./PerformanceLaneRow";
import type { PerformanceCargoClassRow } from "./PerformanceCargoClassRow";
import {
  PerformanceCargoClassRowFromJSON,
  PerformanceCargoClassRowFromJSONTyped,
  PerformanceCargoClassRowToJSON,
  PerformanceCargoClassRowToJSONTyped,
} from "./PerformanceCargoClassRow";
import type { PerformanceBillingHygiene } from "./PerformanceBillingHygiene";
import {
  PerformanceBillingHygieneFromJSON,
  PerformanceBillingHygieneFromJSONTyped,
  PerformanceBillingHygieneToJSON,
  PerformanceBillingHygieneToJSONTyped,
} from "./PerformanceBillingHygiene";
import type { PerformanceServiceQuality } from "./PerformanceServiceQuality";
import {
  PerformanceServiceQualityFromJSON,
  PerformanceServiceQualityFromJSONTyped,
  PerformanceServiceQualityToJSON,
  PerformanceServiceQualityToJSONTyped,
} from "./PerformanceServiceQuality";

/**
 *
 * @export
 * @interface PerformanceResponse
 */
export interface PerformanceResponse {
  /**
   *
   * @type {PortalCurrency}
   * @memberof PerformanceResponse
   */
  currency: PortalCurrency;
  /**
   *
   * @type {PerformanceKpis}
   * @memberof PerformanceResponse
   */
  kpis: PerformanceKpis;
  /**
   *
   * @type {PerformanceCompetitiveness}
   * @memberof PerformanceResponse
   */
  competitiveness?: PerformanceCompetitiveness;
  /**
   *
   * @type {Array<PerformanceLaneRow>}
   * @memberof PerformanceResponse
   */
  lanes: Array<PerformanceLaneRow>;
  /**
   *
   * @type {Array<PerformanceOnTimeMonthRow>}
   * @memberof PerformanceResponse
   */
  onTimeByMonth: Array<PerformanceOnTimeMonthRow>;
  /**
   *
   * @type {Array<PerformanceCargoClassRow>}
   * @memberof PerformanceResponse
   */
  cargoProfile: Array<PerformanceCargoClassRow>;
  /**
   *
   * @type {Array<PerformanceVolumeMonthRow>}
   * @memberof PerformanceResponse
   */
  volumeByMonth: Array<PerformanceVolumeMonthRow>;
  /**
   *
   * @type {PerformanceServiceQuality}
   * @memberof PerformanceResponse
   */
  serviceQuality?: PerformanceServiceQuality;
  /**
   *
   * @type {PerformanceFreightProfile}
   * @memberof PerformanceResponse
   */
  freightProfile?: PerformanceFreightProfile;
  /**
   *
   * @type {PerformanceBillingHygiene}
   * @memberof PerformanceResponse
   */
  billingHygiene?: PerformanceBillingHygiene;
  /**
   *
   * @type {PerformanceCspUtilisation}
   * @memberof PerformanceResponse
   */
  cspUtilisation?: PerformanceCspUtilisation;
}

/**
 * Check if a given object implements the PerformanceResponse interface.
 */
export function instanceOfPerformanceResponse(
  value: object,
): value is PerformanceResponse {
  if (!("currency" in value) || value["currency"] === undefined) return false;
  if (!("kpis" in value) || value["kpis"] === undefined) return false;
  if (!("lanes" in value) || value["lanes"] === undefined) return false;
  if (!("onTimeByMonth" in value) || value["onTimeByMonth"] === undefined)
    return false;
  if (!("cargoProfile" in value) || value["cargoProfile"] === undefined)
    return false;
  if (!("volumeByMonth" in value) || value["volumeByMonth"] === undefined)
    return false;
  return true;
}

export function PerformanceResponseFromJSON(json: any): PerformanceResponse {
  return PerformanceResponseFromJSONTyped(json, false);
}

export function PerformanceResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PerformanceResponse {
  if (json == null) {
    return json;
  }
  return {
    currency: PortalCurrencyFromJSON(json["currency"]),
    kpis: PerformanceKpisFromJSON(json["kpis"]),
    competitiveness:
      json["competitiveness"] == null
        ? undefined
        : PerformanceCompetitivenessFromJSON(json["competitiveness"]),
    lanes: (json["lanes"] as Array<any>).map(PerformanceLaneRowFromJSON),
    onTimeByMonth: (json["onTimeByMonth"] as Array<any>).map(
      PerformanceOnTimeMonthRowFromJSON,
    ),
    cargoProfile: (json["cargoProfile"] as Array<any>).map(
      PerformanceCargoClassRowFromJSON,
    ),
    volumeByMonth: (json["volumeByMonth"] as Array<any>).map(
      PerformanceVolumeMonthRowFromJSON,
    ),
    serviceQuality:
      json["serviceQuality"] == null
        ? undefined
        : PerformanceServiceQualityFromJSON(json["serviceQuality"]),
    freightProfile:
      json["freightProfile"] == null
        ? undefined
        : PerformanceFreightProfileFromJSON(json["freightProfile"]),
    billingHygiene:
      json["billingHygiene"] == null
        ? undefined
        : PerformanceBillingHygieneFromJSON(json["billingHygiene"]),
    cspUtilisation:
      json["cspUtilisation"] == null
        ? undefined
        : PerformanceCspUtilisationFromJSON(json["cspUtilisation"]),
  };
}

export function PerformanceResponseToJSON(json: any): PerformanceResponse {
  return PerformanceResponseToJSONTyped(json, false);
}

export function PerformanceResponseToJSONTyped(
  value?: PerformanceResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    currency: PortalCurrencyToJSON(value["currency"]),
    kpis: PerformanceKpisToJSON(value["kpis"]),
    competitiveness: PerformanceCompetitivenessToJSON(value["competitiveness"]),
    lanes: (value["lanes"] as Array<any>).map(PerformanceLaneRowToJSON),
    onTimeByMonth: (value["onTimeByMonth"] as Array<any>).map(
      PerformanceOnTimeMonthRowToJSON,
    ),
    cargoProfile: (value["cargoProfile"] as Array<any>).map(
      PerformanceCargoClassRowToJSON,
    ),
    volumeByMonth: (value["volumeByMonth"] as Array<any>).map(
      PerformanceVolumeMonthRowToJSON,
    ),
    serviceQuality: PerformanceServiceQualityToJSON(value["serviceQuality"]),
    freightProfile: PerformanceFreightProfileToJSON(value["freightProfile"]),
    billingHygiene: PerformanceBillingHygieneToJSON(value["billingHygiene"]),
    cspUtilisation: PerformanceCspUtilisationToJSON(value["cspUtilisation"]),
  };
}
